import { useMemo } from "react";
import { TableSelectionMode } from "../../ducks/table/types";
import { useTableSelection } from "./useTableSelection";

export const useTableSelectedCount = (layerName?: string) => {
  const [tableSelection] = useTableSelection();

  const isSelectionAll = useMemo(
    () => tableSelection?.[layerName]?.mode === TableSelectionMode.All,
    [layerName, tableSelection],
  );

  const isSelectedAll = useMemo(
    () => isSelectionAll && tableSelection?.[layerName]?.processedRows?.length === 0,
    [isSelectionAll, layerName, tableSelection],
  );

  const isSelectedSome = useMemo(
    () =>
      tableSelection?.[layerName]?.mode === TableSelectionMode.None &&
      tableSelection?.[layerName]?.processedRows?.length > 0,
    [layerName, tableSelection],
  );

  const selectedCount = useMemo(() => {
    return isSelectedAll
      ? tableSelection?.[layerName]?.totalRows
      : isSelectionAll
      ? tableSelection?.[layerName]?.totalRows - tableSelection?.[layerName]?.processedRows?.length
      : tableSelection?.[layerName]?.processedRows?.length;
  }, [layerName, isSelectedAll, isSelectionAll, tableSelection]);

  return {
    selectedCount,
    isSelectedAll,
    isSelectionAll,
    isSelectedSome,
  };
};
